<template>
  <div class="foot">
    <div class="foot-top">
      <div class="foot-left">
        <img src="@/assets/logo3.png"/>
      </div>
      <div class="foot-right">
        <div>
          <img src="@/assets/tag4.png"/>
          <span>地址：千鹤家园1号楼2403，北京市，朝阳区，中国</span>
        </div>
        <div>
          <img src="@/assets/tag3.png"/>
          <span>邮箱：info@tri-think.cn</span>
        </div>
        <div>
          <img src="@/assets/tag5.png"/>
          <span>Copyright@2018-2025 TRI-THINK All Rights Reserved</span>
        </div>
        <div>
          <img src="@/assets/tag2.png"/>
          <span><a href="https://beian.miit.gov.cn" target="_blank">京ICP备2020042206号-1</a></span>
        </div>
      </div>
    </div>
    <div class="foot-bottom">
      <img src="@/assets/er.png" />
      <span>官方公众号</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HomeView',
  data() {
    return {
    }
  },
  methods: {
    
  }
}
</script>
<style scoped lang="scss">
.foot {
  width:100%;
  height:625px;
  background:#1b1918;
  padding: 80px 0 80px 90px;
  .foot-top{
    width: 100%;
    height: 206px;
    display: flex;
    .foot-left {
      width: 156px;
      height: 206px;
      display: flex;
      align-items: center;
      img {
        width: 156px;
        height: 156px;
      }
    }
    .foot-right {
      margin-left: 67px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      div {
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        img {
          width: 28px;
          height: 28px;
        } 
        span {
          font-family:Source Han Sans CN;
          color:#ffffff;
          font-size:26px;
          margin-left: 12px;
          a {
            color:#ffffff;
            cursor: pointer;
          }
        }
      }
    }
  }
  .foot-bottom {
    width: 100%;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-top: 75px;
    img {
      width: 155px;
      height: 155px;
    }
    span {
      font-family:Source Han Sans CN;
      color:#ffffff;
      font-size:26px;
      opacity: 0.6;
    }
  }
}
</style>
